import { render, staticRenderFns } from "./GeneticSimilaritiesIcon.vue?vue&type=template&id=5359a1da&scoped=true"
import script from "./GeneticSimilaritiesIcon.vue?vue&type=script&lang=js"
export * from "./GeneticSimilaritiesIcon.vue?vue&type=script&lang=js"
import style0 from "./GeneticSimilaritiesIcon.vue?vue&type=style&index=0&id=5359a1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5359a1da",
  null
  
)

export default component.exports